import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

export interface ArchiveClientsResponse {
	archived: boolean
	matched: number
	modified: number
}

/**
 * Archive or restore clients. Archiving suspends the accounts and
 * hides them from the main clients list.
 */
export const archiveClients = async (ids: string[], archived: boolean) => {
	try {
		const { data } = await axios.patch<ArchiveClientsResponse>('client/archive', {
			ids,
			archived,
		})
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default archiveClients
